import {
  MATERIAL_TABLE_DEFAULT_ITEM,
  PROBLEMS_TABLE_ITEMS,
  MATERIAL_TABLE_ITEMS,
} from './constants'
import humps from 'humps'

export function formatProblemsList(problems) {
  return (problems ?? []).map(problem => ({
    value: problem?.id,
    label: problem?.name,
  }))
}

export function formatBudgetResolutionsForGrid(budgetResolutions) {
  return budgetResolutions?.length
    ? budgetResolutions.map((item, index) => ({
        ...item,
        index,
      }))
    : []
}

export function findProblemItemByField(field) {
  return PROBLEMS_TABLE_ITEMS.find(tableItem => tableItem.field === field)
}

export function findMaterialItemByField(field) {
  return MATERIAL_TABLE_ITEMS.find(col => col.field === field)
}

export function handleWarrantyMonths(warrantyMonths) {
  if (warrantyMonths === 0) {
    return 'Sem garantia'
  }
  return `${warrantyMonths} ${warrantyMonths > 1 ? 'meses' : 'mês'}`
}

export function findMaterialsErrorMessage(errors, index) {
  const error = errors?.materials?.[index]

  if (!error) return ''
  return Object.values(error)?.filter(({ message }) => message)?.[0]?.message ?? ''
}

export function formatMaterialsPayload(materials) {
  const materialsWithoutDescription =
    materials?.length > 0 ? materials?.filter(item => item?.description) : []
  return materialsWithoutDescription?.length > 0
    ? materialsWithoutDescription?.map(material => humps.decamelizeKeys(material))
    : []
}

export function formatDefaultBudgetResolution(budgetResolution) {
  if (!budgetResolution) return {}

  return {
    ...budgetResolution,
    problem: {
      value: budgetResolution?.problem,
      label: budgetResolution?.problemText,
    },
    compartment: {
      label: budgetResolution?.compartment || '',
    },
    materials: budgetResolution?.materials?.length
      ? budgetResolution.materials.map(material => ({
          ...MATERIAL_TABLE_DEFAULT_ITEM,
          ...material,
          description: material?.description || '',
        }))
      : [MATERIAL_TABLE_DEFAULT_ITEM],
  }
}

export function calculateTotalValue(data) {
  const itemsSum =
    data?.materials?.reduce((acc, item) => acc + Number(item?.total), 0) +
      Number(data?.laborValue) || 0
  return Math.ceil(itemsSum * 100) / 100
}

function appendFormData(formData, key, value) {
  if (Array.isArray(value)) {
    if (key === 'problem_media') {
      const fileItems = value.filter(item => item instanceof File)
      fileItems.forEach(file => {
        formData.append(key, file, file.name)
      })

      const objectItems = value.filter(item => !(item instanceof File))
      if (objectItems.length > 0) {
        formData.append(
          'problem_media_json',
          JSON.stringify(objectItems.map(item => humps.decamelizeKeys(item)))
        )
      }
    } else if (value.every(item => item instanceof File)) {
      value.forEach(file => {
        formData.append(key, file, file.name)
      })
    } else if (value.every(item => typeof item === 'object' && item !== null)) {
      formData.append(key, JSON.stringify(value.map(item => humps.decamelizeKeys(item))))
    } else {
      value.forEach(item => {
        formData.append(key, item)
      })
    }
  } else if (
    value &&
    typeof value === 'object' &&
    !(value instanceof Date) &&
    !(value instanceof File)
  ) {
    formData.append(key, JSON.stringify(humps.decamelizeKeys(value)))
  } else {
    formData.append(key, value)
  }
}

export function createFormDataBudgetResolution(payload) {
  const formData = new FormData()

  Object.keys(payload).forEach(key => {
    appendFormData(formData, humps.decamelize(key), payload[key])
  })

  return formData
}

export function sanitizeResolution(resolution) {
  return {
    id: resolution.id,

    problem: { label: resolution.problemText },

    warrantyMonths: resolution.warrantyMonths,
    isServiceMandatory: resolution.isServiceMandatory,
    problemDescription: resolution.problemDescription,
    serviceDescription: resolution.serviceDescription,
    problemMedia: resolution.problemMedia,

    materials:
      resolution.materials?.map(m => ({
        id: m.id,
        description: m.description,
        quantity: m.quantity,
        unitPrice: m.unitPrice,
        total: m.total,
      })) ?? [],

    singleServicePrice: resolution.singleServicePrice,
    laborValue: resolution.laborValue,
    numberOfProfessionals: resolution.numberOfProfessionals,
    laborTimeHours: resolution.laborTimeHours,
    total: resolution.total,
  }
}
